import { useForkRef } from '@cian/react-utils';
import { Ref, useEffect, useRef, useState } from 'react';

export const useWithCounter = <T extends HTMLElement>(
  count: number | undefined,
  ref: Ref<T>,
): [boolean, ((value: T) => void) | null] => {
  const [isCounterVisible, setCounterVisible] = useState(false);
  const overflowedElementRef = useRef<T>(null);

  useEffect(() => {
    const root = overflowedElementRef.current;

    if (!root) {
      return;
    }

    // Текст обрезается во вложенном span кнопки ui-kit, поэтому проверяем все потомки, а не первого ребёнка
    const isTextOverflowed = Array.from(root.querySelectorAll<HTMLElement>('*')).some(
      element => element.offsetWidth < element.scrollWidth,
    );

    setCounterVisible(isTextOverflowed);
  }, [overflowedElementRef, count]);

  const setMultiplyRef = useForkRef(ref, overflowedElementRef);

  return [isCounterVisible, setMultiplyRef];
};
